module.exports = __webpack_public_path__ + "static/media/061-search.b6b82c99.svg";